import { AuthenticationResult, EventMessage, EventType, PublicClientApplication } from '@azure/msal-browser';
import MsalContract from '../contracts/msal.contract';
import ConfigService from './config.service';

class MsalClass {
    private static instance: MsalContract;

    private constructor() {
        // private constructor to prevent direct instantiation
    }

    public static async getInstance(): Promise<MsalContract> {
        if (!MsalClass.instance) {
            console.log('New MSAL Instance');
            const params = new URLSearchParams(window.location.search);
            let impersonatedUser = params.get('impersonatedUser');

            if (window.location.href.includes('internal') || sessionStorage.getItem('isInternal') === 'true') {
                sessionStorage.setItem('isInternal', 'true');

                if (impersonatedUser && impersonatedUser !== '') {
                    sessionStorage.setItem('impersonatedUser', impersonatedUser);
                } else {
                    impersonatedUser = sessionStorage.getItem('impersonatedUser');
                }

                MsalClass.instance = {
                    PCA: new PublicClientApplication(ConfigService.azureADConfig),
                    AuthRequest: ConfigService.azureADScope,
                    Mode: 'AzureAD',
                    ImpersonatedUser: impersonatedUser!
                };
            } else {
                MsalClass.instance = {
                    PCA: new PublicClientApplication(ConfigService.azureB2CConfig),
                    AuthRequest: ConfigService.azureB2CScope,
                    Mode: 'AzureB2C',
                    ImpersonatedUser: undefined
                };
            }

            await MsalClass.instance.PCA.initialize();

            // Handle redirect response
            const redirectResult = await MsalClass.instance.PCA.handleRedirectPromise();
            if (redirectResult) {
                // Set the active account if login was successful
                MsalClass.instance.PCA.setActiveAccount(redirectResult.account);
            }

            const activeAccount = MsalClass.instance.PCA.getActiveAccount();
            if (!activeAccount) {
                // No active account found. Redirecting to login.
                MsalClass.instance.PCA.loginRedirect(MsalClass.instance.AuthRequest);
            }
        }

        MsalClass.instance.PCA.addEventCallback((event: EventMessage) => {
            if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
                const payload = event.payload as AuthenticationResult;
                const account = payload.account;
                MsalClass.instance.PCA.setActiveAccount(account);
            }
        });

        return MsalClass.instance;
    }
}

const getInstance = MsalClass.getInstance();

const MsalService = {
    getInstance
};

export default MsalService;
